"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("../constant");
var _constant3 = require("@airasia/phoenix-components/components/Link/constant");
var _constant4 = require("./constant");

/**
 * Prop mark with * is from Contract from content service
 */
var _default = {
  PropTypes: {
    imageURL: _propTypes.default.string,
    lowResolutionImageUrl: _propTypes.default.string,
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    hasOverlay: _propTypes.default.bool,
    altText: _propTypes.default.string,
    // alt text to be displayed incase image doesn't load
    headline: _propTypes.default.string,
    // *
    subheadline: _propTypes.default.string,
    // *
    tags: _propTypes.default.arrayOf(_propTypes.default.exact({
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      color: _propTypes.default.oneOf(_constant.ARR_COLORS),
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS)
    })),
    tagTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
    showButton: _propTypes.default.bool,
    placeHolderBackground: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    buttonBorder: _propTypes.default.string,
    buttonBorderRadius: _propTypes.default.string,
    buttonTextColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    buttonBackgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    buttonUrl: _propTypes.default.string,
    buttonText: _propTypes.default.string,
    buttonIcon: _propTypes.default.string,
    buttonTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
    alignButtonContainer: _propTypes.default.string,
    onBannerClick: _propTypes.default.func,
    redirectUrl: _propTypes.default.string,
    redirectUrlTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
    queryParams: _propTypes.default.object,
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    gtmEventData: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    headlineColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    subheadlineColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    alignHeadlineContainer: _propTypes.default.string,
    alignHeadlineVerticalContainer: _propTypes.default.string,
    headlineVerticalContainerTopSpace: _propTypes.default.string,
    headlineVerticalContainerBottomSpace: _propTypes.default.string,
    titleContainerMaxWidth: _propTypes.default.string,
    device: _propTypes.default.oneOf(Object.values(_constant2.DEVICE_TYPE)),
    accessibility: _propTypes.default.exact({
      banner: _propTypes.default.bool,
      headline: _propTypes.default.bool,
      subheadline: _propTypes.default.bool,
      buttonUrl: _propTypes.default.bool,
      buttonText: _propTypes.default.bool,
      backNavigationIcon: _propTypes.default.bool,
      newBanner: _propTypes.default.bool
    }),
    customProperties: _propTypes.default.exact({
      banner: _propTypes.default.object,
      headline: _propTypes.default.object,
      subheadline: _propTypes.default.object,
      overlay: _propTypes.default.object
    }),
    theme: _propTypes.default.string,
    showBackNavigation: _propTypes.default.bool,
    backNavigationHandler: _propTypes.default.func,
    idConfig: _propTypes.default.exact({
      parentName: _propTypes.default.string,
      widgetName: _propTypes.default.string,
      index: _propTypes.default.string
    })
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    width: _constant4.BANNER_DEFAULT_WIDTH,
    height: _constant4.BANNER_DEFAULT_HEIGHT,
    device: _constant2.DEVICE_TYPE.DESKTOP,
    accessibility: {
      banner: true
    },
    customProperties: {},
    showBackNavigation: false,
    showButton: false,
    alignHeadlineVerticalContainer: 'center',
    headlineVerticalContainerTopSpace: '0',
    headlineVerticalContainerBottomSpace: '5%',
    newBanner: false
  }
};
exports.default = _default;